import { useState } from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth, useCoachingRequest } from "@bw/shared/hooks";
import { CoachingGuardianInvite } from "./coaching-guardian-invite";
import { CoachingProposalComposer } from "./coaching-proposal-composer";
import { BusinessLesson, BusinessProposalReview } from "./coaching-workspace-inbox";

export function CoachingRequestDetail() {
  const { requestId = "" } = useParams(), { user } = useAuth();
  return <Request key={`${user?.uid}:${requestId}`} requestId={requestId} />;
}
function Request({ requestId }: { requestId: string }) {
  const query = useCoachingRequest(requestId);
  const [composing, setComposing] = useState(false);
  const item = query.data;
  return <Stack spacing={2} sx={{ p: { xs: 2, md: 3 } }}>
    <Button component={RouterLink} to="/coaching" size="small" sx={{ alignSelf: "flex-start" }}>Back to coaching</Button>
    {query.isError ? <Alert severity="warning">This coaching request is unavailable. Your access may have changed.</Alert>
      : !query.isFetchedAfterMount || !item ? <Typography role="status">Loading coaching request…</Typography>
      : <>
        <Typography component="h1" variant="h4">{item.title}</Typography>
        {item.historical_status ? <Typography>{item.historical_status === "paid" ? "Paid — read-only history" : "Completed — read-only history"}</Typography> : null}
        {item.guardian ? <CoachingGuardianInvite requestId={requestId} guardian={item.guardian} /> : null}
        {item.can_issue && !composing ? <Button size="small" variant="contained" onClick={() => setComposing(true)} sx={{ alignSelf: "flex-start" }}>Create proposal</Button> : null}
        {item.can_issue && composing ? <CoachingProposalComposer requestId={requestId} onClose={() => setComposing(false)} /> : null}
        {item.can_view_proposal && item.revision_id ? <BusinessProposalReview key={item.revision_id} requestId={requestId} revisionId={item.revision_id} /> : null}
        {item.can_view_lesson && item.acceptance_id ? <BusinessLesson acceptanceId={item.acceptance_id} /> : null}
      </>}
  </Stack>;
}
